
  import { Vue, Component, Prop } from "vue-property-decorator";
  import FormGroup from "@/components/form/FormGroup.vue";
  import FormInput from "@/components/form/FormInput.vue";
  import UiButton from "@/components/button/ui-button.vue";
  import TableContenteditable from "@/components/table/table-contenteditable.vue";
  // import CrossIcon from "@/components/icons/CrossIcon.vue";
  import CrossIconBlack from "@/components/icons/CrossIconBlackNew.vue";
  import FormToggle from "@/components/form/FormToggle.vue";

  interface ManagerRules {
    c_email: boolean;
    required_field: boolean;
    managerExists: any[];
    unique: any[];
  }

  interface ContractorRules {
    c_email: boolean;
    required_field: boolean;
    contractorExists: any[];
    unique: any[];
  }
  @Component({
    components: {
      CrossIconBlack,
      TableContenteditable,
      FormGroup,
      UiButton,
      FormInput,
      FormToggle,
    },
  })
  export default class UserInvitationData extends Vue {
    @Prop({ type: Boolean, default: true}) readonly allowedAdding!: boolean;
    @Prop({ type: String, required: true }) readonly companyId!: string;
    @Prop({ type: String, default: undefined }) readonly userEmail?: string;
    @Prop({ type: String, default: undefined }) readonly userGivenName?: string;
    @Prop({ type: String, default: undefined }) readonly userFamilyName?: string;
    @Prop({ type: String, default: undefined }) readonly userId?: string;
    @Prop({ type: Array, default: () => [] }) readonly userSource!: any[];
    @Prop({ type: Number, required: true }) readonly index!: number;
    @Prop({ type: Boolean, default: false }) readonly immediate!: boolean;
    @Prop({ type: Boolean, default: false }) readonly validateCsv!: boolean;
    @Prop({ type: Boolean, default: false }) readonly isManager!: boolean;
    @Prop({ type: Boolean, default: false }) readonly processing!: boolean;
    @Prop({ type: Array, default: () => [] }) readonly usersToCheck!: any[];
    @Prop({ type: Boolean, default: false }) readonly allowDelete!: boolean;
    @Prop({ type: Boolean, default: false }) readonly is_public!: boolean;

    $papa: any;
    csvFilename: string = "";
    animationClass: string = "";

    get isFirstRow(): boolean {
      return this.index === 0;
    }

    get emailFieldTitle(): string | undefined {
      return this.isFirstRow ? "Email" : undefined;
    }

    get firstNameFieldTitle(): string | undefined {
      return this.isFirstRow ? "First Name" : undefined;
    }

    get lastNameFieldTitle(): string |undefined {
      return this.isFirstRow ? "Last Name" : undefined;
    }

    get isPublicTitle(): string | undefined {
      return this.isFirstRow ? "Is Public?" : undefined;
    }

    get deleteButtonStyles(): object {
      return {
        "mt-6": this.isFirstRow,
      };
    }

    get customRules(): object {
      let baseRules = {
        unique: [this.usersToCheck],
        c_email: true,
        required_field: true,
      };

      let managerRules: ManagerRules = {
        ...baseRules,
        managerExists: [this.usersToCheck],
      };

      let contractorRules: ContractorRules = {
        ...baseRules,
        contractorExists: [this.usersToCheck],
      };

      return !this.isManager ? contractorRules : managerRules;
    }

    get localEmail(): string {
      return this.userEmail || "";
    }

    set localEmail(val: string) {
      this.$emit("update:userEmail", val.trim());
    }

    get emailFieldName(): string {
      return `email${this.index}`;
    }

    get nameFieldName(): string {
      return `givenName${this.index}`;
    }

    get surnameFieldName(): string {
      return `familyName${this.index}`;
    }

    get isPublicFieldName(): string {
      return `familyName${this.index}`;
    }

    getErrors(errors: string[], changed: boolean): string[] {
      const validationErrors = (this.validateCsv || changed) ? errors : [];

      if (this.allowedAdding) {
        return validationErrors;
      }
      return [
        ...validationErrors,
        "To add this manager you need to upgrade your subscription",
      ];
    }

    handleEmailUpdate(value: string): void {
      this.localEmail = value.trim();
    }

    handleGivenNameUpdate(value: string): void {
      this.$emit("update:userGivenName", value.trim());
    }

    handleFamilyNameUpdate(value: string): void {
      this.$emit("update:userFamilyName", value.trim());
    }

    handleIdFound(value: string | null): void {
      this.$emit("update:userId", value);
    }

    toggleIsPublic(value: boolean): void {
      this.$emit("update:is_public", !value);
    }

    handleRemoveClick(): void {
      if (!this.allowDelete) {
        return;
      }

      this.animationClass = "animate-height-56-400 animate-forward";

      setTimeout(() => {
        this.$emit("delete", this.index);
        this.animationClass = "";
      }, 400);
    }
  }
